export interface IAttachment {
  name?: string;
  original_name_url?: string;
  size?: number;
  type?: string;
  url?: string;
}

export class Attachment implements IAttachment {
  name: string;
  original_name_url: string;
  size: number;
  type: string;
  url: string;
  deleteUrl: string;

  constructor( data: IAttachment ) {
    this.name = data.name;
    this.original_name_url = data.original_name_url;
    this.size = data.size;
    this.type = data.type;
    this.url = data.url;
    this.deleteUrl = data.url;
  }
}



// WEBPACK FOOTER //
// ./app/components/attachment-upload-btn/attachment.ts